module.exports = __webpack_public_path__ + "static/media/nodata.d1152db8.png";